import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { Ref, toValue } from "vue";

import { useServices } from "@/configuration/plugins/app/app-provider.configuration";
import { SiteQueryKeys } from "@/data/api/site-query-keys";
import { ApplianceMutationKeys } from "@/data/api/v4b/appliance/appliance-mutation-keys";
import { SiteProgrammingRangeQueryKeys } from "@/data/api/v4b/site-programming-range/site-programming-range-query-keys";
import { V4HSiteId } from "@/data/common/ids";
import { BulkMoveAppliancesRequest } from "@/domains/v4b/site-section/site-section.types";

export function useSiteSectionsBulkMoveAppliancesMutation(siteId: Ref<V4HSiteId>) {
  const v4b = useServices().v4b.clientSdk;
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ApplianceMutationKeys.bulkMove(),
    mutationFn: (request: BulkMoveAppliancesRequest) => v4b.appliance.bulkMove(toValue(siteId), request),
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: SiteQueryKeys.sections(siteId),
      });

      await queryClient.removeQueries({
        queryKey: SiteProgrammingRangeQueryKeys.findPlanning(siteId),
      });
    },
    retry: 0,
  });
}
